import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import MembershipScheduleList from './MembershipScheduleList';
import translate from 'components/hoc/translate';
import Title from 'components/ui/general/Title';

const MembershipSchedulesListContainer = (props) => {

    const { resource, translate } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('menu.sidebar.membership_schedules') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <MembershipScheduleList { ...props } />
        </div>
    );

};

MembershipSchedulesListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(MembershipSchedulesListContainer);


// WEBPACK FOOTER //
// ./src/pages/membership-schedules/list/MembershipSchedulesListContainer.js